import React from 'react'
import backgroundImage from '../assets/background/9.jpg';
function CallToAction() {
  return (
    <section class="call-to-action-five">
        <div className="bg bg-image" style={{backgroundImage: `url(${backgroundImage})`}}></div>
         {/* <div class="bg bg-image" style="background-image: url(`images/background/9.jpg`)"></div> */}

        <div class="auto-container">
            <div class="inner-box">
                <div class="sec-title light text-center">
                    <div class="icon-flower-21"></div>
                    <h2>
                    First time we meet <br />
                    Our story proves that real
                    </h2>
                </div>
            </div>
        </div>
    </section>
  )
}

export default CallToAction